import actionTypes from './actionTypes';
import type { RateLineSide } from '../../constants';
import type { IGridFilter, IRateLine, IRateLineHeader } from '../../sharedTypes';
import type { IExportPayload, ILoadHeadersPayload, ILoadLinesPayload } from './types';

const actions = {
  loadHeadersRequest: (payload: ILoadHeadersPayload) => ({
    type: actionTypes.LOAD_HEADERS_REQUEST,
    payload,
  }),
  loadHeadersSuccess: (cacheKey: string, headers: IRateLineHeader[], dimensions: IRateLineHeader[]) => ({
    type: actionTypes.LOAD_HEADERS_SUCCESS,
    payload: { cacheKey, headers, dimensions },
  }),
  loadHeadersError: () => ({ type: actionTypes.LOAD_HEADERS_ERROR }),
  loadLinesRequest: (payload: ILoadLinesPayload) => ({
    type: actionTypes.LOAD_LINES_REQUEST,
    payload,
  }),
  loadLinesSuccess: (payload: {
    page: number;
    rows: IRateLine[];
    filteredCount: number;
    sortableColumns: string[];
    filters: IGridFilter[];
  }) => ({ type: actionTypes.LOAD_LINES_SUCCESS, payload }),
  loadLinesError: (page: number) => ({ type: actionTypes.LOAD_LINES_ERROR, payload: { page } }),
  exportRequest: (payload: IExportPayload) => ({ type: actionTypes.EXPORT_REQUEST, payload }),
  exportSettled: () => ({ type: actionTypes.EXPORT_SETTLED }),
  sideChanged: (side: RateLineSide) => ({ type: actionTypes.SIDE_CHANGED, payload: { side } }),
  clearStore: () => ({ type: actionTypes.CLEAR_STORE }),
};

export default actions;
